module.exports = __webpack_public_path__ + "img/smallTruck-orange.2acb88d0.svg";